import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Hero from "../components/Hero";
import PreviewCompatibleImage from "../components/PreviewCompatibleImage";
import AboveFooter from "../components/AboveFooter";
import SEO from "../components/SEO";
import background from "../img/service_section_bg_2.png";
import Testimonial from "../components/base/Testimonial";

export function Head() {
  return <title>Hello World</title>;
}

export const IndexPageTemplate = ({
  hero,
  contactus,
  servicesSection,
  sectionlist,
  fixedimagesection,
}) => (
  <div>
    <SEO title={hero.title} description={hero.description} homepage={true} />
    <Hero data={hero} />
    <Testimonial />
    <div style={{ background: "#1a1b28" }}>
      <div
        className="section"
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: `center center`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "700",
        }}
      >
        <div
          className="container"
          style={{
            color: "white",
          }}
        >
          <h1
            className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-2-widescreen has-text-centered hp-title"
            style={{ paddingTop: "2rem" }}
          >
            {servicesSection.title}
          </h1>

          <div
            className="columns serviceCard-section"
            style={{ maxWidth: "100%" }}
          >
            {servicesSection.list.map((serviceCard, i) => (
              <div
                key={i}
                className="column is-3"
                style={{ padding: "0 1rem" }}
              >
                <div className="serviceCard-wrapper">
                  <div className="serviceCard-content has-text-centered">
                    <p className="serviceCard-number">
                      {serviceCard.secondtitle}
                    </p>
                    <p className="serviceCard-description">
                      {serviceCard.description1}
                    </p>
                    <p className="serviceCard-source">
                      {serviceCard.description2}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="container" id="touch">
          <div
            className="content-wrapper has-text-centered columns"
            style={{
              paddingTop: "5rem",
              paddingBottom: "2rem",
              color: "white",
            }}
          >
            <h1 className="is-size-2 has-text-weight-bold hp-title">
              {servicesSection.serviceTitle}
            </h1>
            <p
              className="is-size-5"
              style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
              {servicesSection.serviceDescription}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div>
      {sectionlist.list.map((item, i) => {
        // Determine if we need normal slant or alt slant
        const isLeftSlant = i % 4 === 0 || i % 4 === 3;
        const isAltSlant = i === 2 || i === 3;

        const slantClass = isLeftSlant
          ? isAltSlant
            ? "slanted-bg-image-left-alt"
            : "slanted-bg-image-left"
          : isAltSlant
          ? "slanted-bg-image-right-alt"
          : "slanted-bg-image-right";

        return (
          <div
            key={i}
            className="section"
            style={{
              position: "relative",
              backgroundColor: item.sectionbg,
              overflow: "hidden",
            }}
          >
            <div
              className={slantClass}
              style={{
                backgroundImage: `url(${
                  item.image?.childImageSharp?.fluid?.src || item.image
                })`,
              }}
            ></div>

            <div className="container">
              <div
                className="columns content-image-wrapper"
                style={{ maxWidth: "100%" }}
              >
                {isLeftSlant ? (
                  <>
                    <div
                      className="column is-5 sideimage"
                      style={{
                        backgroundImage: `url(${
                          item.image?.childImageSharp?.fluid?.src || item.image
                        })`,
                        backgroundSize: "cover",
                      }}
                    ></div>

                    <div className="spacer"></div>

                    <div className="column is-5 content-wrapper">
                      <h1
                        className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen hp-title"
                        style={{
                          color: `${item.textcolor}`,
                          lineHeight: "1",
                          marginTop: "1rem",
                        }}
                      >
                        {item.title} <br /> {item.secondtitle}
                      </h1>
                      <p
                        style={{ color: `${item.textcolor}`, margin: "2rem 0" }}
                      >
                        {item.description}
                      </p>
                      {item.orderlist &&
                        item.orderlist.list &&
                        item.orderlist.list.length > 0 && (
                          <ul
                            style={{
                              listStyleType: "disc",
                              paddingLeft: "3rem",
                              marginBottom: "2rem",
                              color: `${item.textcolor}`,
                            }}
                          >
                            {item.orderlist.list.map((orderItem, index) => (
                              <li key={index}>{orderItem.title}</li>
                            ))}
                          </ul>
                        )}
                      <div className="btn-wrapper">
                        <a href={item.buttonlink}>
                          <button
                            className="btn-golden"
                            style={{ marginBottom: "2rem" }}
                          >
                            {item.buttontxt}
                          </button>
                        </a>
                      </div>
                    </div>
                  </>
                ) : null}

                {!isLeftSlant ? (
                  <>
                    <div className="column is-5 pl-mb-5 content-wrapper">
                      <h1
                        className="has-text-weight-bold is-size-4-mobile is-size-3-tablet is-size-2-widescreen hp-title"
                        style={{
                          color: `${item.textcolor}`,
                          lineHeight: "1",
                          marginTop: "1rem",
                        }}
                      >
                        {item.title} <br /> {item.secondtitle}
                      </h1>
                      <p
                        style={{ color: `${item.textcolor}`, margin: "2rem 0" }}
                      >
                        {item.description}
                      </p>
                      {item.orderlist &&
                        item.orderlist.list &&
                        item.orderlist.list.length > 0 && (
                          <ul
                            style={{
                              listStyleType: "disc",
                              paddingLeft: "3rem",
                              marginBottom: "2rem",
                              color: `${item.textcolor}`,
                            }}
                          >
                            {item.orderlist.list.map((orderItem, index) => (
                              <li key={index}>{orderItem.title}</li>
                            ))}
                          </ul>
                        )}
                      <div className="btn-wrapper">
                        <a href={item.buttonlink}>
                          <button
                            className="btn-golden"
                            style={{ marginBottom: "2rem" }}
                          >
                            {item.buttontxt}
                          </button>
                        </a>
                      </div>
                    </div>

                    <div className="spacer"></div>

                    <div
                      className="column is-5 pl-mb-5 sideimage"
                      style={{
                        backgroundImage: `url(${
                          item.image?.childImageSharp?.fluid?.src || item.image
                        })`,
                        backgroundSize: "cover",
                      }}
                    ></div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
    <AboveFooter data={fixedimagesection} height="600px" />
  </div>
);

IndexPageTemplate.propTypes = {
  hero: PropTypes.object,
  contactus: PropTypes.object,
  imageSection: PropTypes.object,
  servicesSection: PropTypes.shape({
    title: PropTypes.string,
    list: PropTypes.array,
  }),
  sectionlist: PropTypes.shape({
    title: PropTypes.string,
    list: PropTypes.array,
  }),
  fixedimagesection: PropTypes.object,
};

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Layout>
      <IndexPageTemplate
        hero={frontmatter.hero}
        contactus={frontmatter.contactus}
        servicesSection={frontmatter.servicesSection}
        sectionlist={frontmatter.sectionlist}
        fixedimagesection={frontmatter.fixedimagesection}
      />{" "}
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        hero {
          title
          secondtitle
          image {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          midimage {
            alt
            image {
              childImageSharp {
                fluid(maxWidth: 1300, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          sideimage {
            alt
            align
            image {
              childImageSharp {
                fluid(maxWidth: 1300, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          description
          description2
          buttontxt
          buttonlink
        }
        servicesSection {
          title
          list {
            secondtitle
            description1
            description2
          }
          serviceTitle
          serviceDescription
        }
        sectionlist {
          title
          list {
            title
            secondtitle
            sectionbg
            textcolor
            description
            orderlist {
              list {
                title
              }
            }
            buttontxt
            buttonlink
            image {
              childImageSharp {
                fluid(maxWidth: 2500, maxHeight: 1150, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        fixedimagesection {
          sideimage {
            childImageSharp {
              fluid(maxWidth: 800, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          title
          secondtitle
          thirdtitle
          description
          buttontxt
          link
          description2
          image {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          height
        }
      }
    }
  }
`;
